import { BrowserRouter as Router, Route, Link, Routes, useLocation } from "react-router-dom";

import { useState, useEffect } from "react";
import MainStat from "./pages/MainStat";
import IndexMap from "./pages/Index";
import SSO from "./components/Sso";
import Maps from "./pages/Maps";
import AppWraper from "./pages/AppWraper";
import { CheckIfToken,RequireToken } from "./services/Auth/Auth";

function App() {
  const [error, setError] = useState()
  const [auth, setAuth] = useState()

  return (
    <Router>
      <Routes>

        <Route
          path={'/'}
          element={

            <AppWraper layout={<IndexMap /> } customCss={'no_height'} page={'/stat'} />

          }
        />
        <Route
          path={'/table-statistics'}
          element={
            <RequireToken>
              <AppWraper layout={<MainStat />} customCss={'no_height'} page={'/stat'} />
            </RequireToken>
          }
        />
        <Route
          path={'/map-statistics'}
          element={

            <AppWraper layout={<Maps />} customCss={'no_height'} page={'/stat'} />

          }
        />
        <Route
          path={'/login/:token?'}
          element={

            <CheckIfToken getError={setError} setAuth={setAuth} session_auth={auth}>
              <AppWraper layout={<SSO />} customCss={'no_height'} page={'/stat'} />
            </CheckIfToken>

          }
        />
      </Routes>
    </Router>
  );
}

export default App;
